import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { PackageType } from 'src/common/models/multi-item/multi-item-types';
import { getDateRangeFromSearchCriteria } from 'src/common/stores/adapters/bex-api/common/search-input-adapter';
import { getRooms } from 'src/common/utils/recommendation-utils';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { DiscoveryCardContentSize, DiscoveryContainerType, DiscoveryOfferingType, DiscoveryPriceStrategy, DiscoveryRecommendationInputContext, DiscoveryRecommendationStrategy, LineOfBusinessDomain, RecommendationsModule } from '@shared-ui/retail-recommendation-module';
import { adaptSearchCriteria } from 'stores/adapters/bex-api/common/search-criteria-adapter';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';
import { EgRecsConfigIds, EgRecsPlacementIds } from 'constants/eg-recs-placements';
export const RecommendationsCarouselWrapper = inject('searchResults', 'multiItem', 'context', 'searchCriteria')(observer(({
  searchResults,
  multiItem,
  context,
  searchCriteria
}) => {
  var _a;
  const packageType = multiItem === null || multiItem === void 0 ? void 0 : multiItem.getPackageType();
  const {
    regionId,
    rooms
  } = (searchResults === null || searchResults === void 0 ? void 0 : searchResults.searchCriteria) || {};
  const dates = (searchResults === null || searchResults === void 0 ? void 0 : searchResults.searchCriteria) ? getDateRangeFromSearchCriteria(searchResults.searchCriteria) : null;
  let placementId;
  let configId;
  switch (context === null || context === void 0 ? void 0 : context.site.brand) {
    case 'expedia':
      if (packageType === 'FH') {
        configId = EgRecsConfigIds.EXPEDIA_FH_PACKAGE_TYPE;
      } else if (packageType === 'FHC') {
        configId = EgRecsConfigIds.EXPEDIA_FHC_PACKAGE_TYPE;
      } else if (packageType === 'HC') {
        configId = EgRecsConfigIds.EXPEDIA_HC_PACKAGE_TYPE;
      }
      placementId = EgRecsPlacementIds.PROPERTY_RECS_PLACEMENT_ID_EXPEDIA;
      break;
    case 'hotels':
      configId = EgRecsConfigIds.HOTELS_LODGING_PACKAGE_TYPE;
      placementId = EgRecsPlacementIds.PROPERTY_RECS_PLACEMENT_ID_HOTELS;
      break;
    case 'vrbo':
      placementId = EgRecsPlacementIds.PROPERTY_RECS_PLACEMENT_ID_VRBO;
      break;
    default:
      if (packageType === 'FH') {
        configId = EgRecsConfigIds.COMET_FH_PACKAGE_TYPE;
      } else if (packageType === 'FHC') {
        configId = EgRecsConfigIds.COMET_FHC_PACKAGE_TYPE;
      } else if (packageType === 'HC') {
        configId = EgRecsConfigIds.COMET_HC_PACKAGE_TYPE;
      }
      placementId = EgRecsPlacementIds.PROPERTY_RECS_PLACEMENT_ID_COMET;
  }
  if (!regionId || !rooms || packageType === PackageType.FC) return null;
  const adaptedSearchCriteria = context && searchCriteria && ((_a = adaptSearchCriteria(context, searchCriteria)) === null || _a === void 0 ? void 0 : _a.secondary);
  return React.createElement(EGDSSpacing, {
    padding: {
      blockstart: 'three'
    }
  }, React.createElement("div", {
    "data-stid": "destination-recs"
  }, React.createElement(Experiment, {
    name: (context === null || context === void 0 ? void 0 : context.site.brand) === 'hotels' ? 'Web_Hcom_Alternative_Destinations_Recs_on_Lodgings_SRP' : 'Web_BEXG_Alternative_Destinations_Recs_on_Packages_Lodging_SRP'
  }, React.createElement(ExperimentControl, null), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(SimpleLazyLoadWrapper, {
    placeholder: React.createElement(React.Fragment, null)
  }, React.createElement(RecommendationsModule, {
    inputs: {
      contentSize: DiscoveryCardContentSize.FOUNDATION,
      offeringType: DiscoveryOfferingType.DESTINATION,
      strategy: DiscoveryRecommendationStrategy.ALTERNATIVE,
      containerType: DiscoveryContainerType.CAROUSEL,
      priceStrategy: DiscoveryPriceStrategy.NONE,
      input: [DiscoveryRecommendationInputContext.DESTINATION],
      recommendationContext: {
        outputLineOfBusiness: LineOfBusinessDomain.UNCLASSIFIED,
        destination: {
          placeId: {
            id: regionId
          }
        },
        lodging: {
          checkin: dates === null || dates === void 0 ? void 0 : dates.checkInDate,
          checkout: dates === null || dates === void 0 ? void 0 : dates.checkOutDate,
          rooms: getRooms(rooms),
          searchCriteria: adaptedSearchCriteria
        },
        pageId: 'SR'
      },
      placementId: placementId,
      configurationIdentifier: configId
    }
  }))))));
}));